import React from 'react';
import styled from 'styled-components/macro';
import HtmlParser from 'html-react-parser';

import { palette, fontDefault, fontDefaultAlt } from '@mirinae/react-ui';
import { os } from '@mirinae/js-utils/utils/userAgent';

import { LessonButton } from '@mirinae/lessons/modules/defines/styles';
import { lessonsPalette, zIndex } from '@mirinae/lessons/modules/defines/styles';

import IconExitDoor from '@mirinae/lessons/components/svg/icon-exit-door.svg';
import IconCrown from '@mirinae/lessons/components/svg/icon-crown.svg';
import IconClock from '@mirinae/lessons/components/svg/icon-clock.svg';
import IconCookie from '@mirinae/lessons/components/svg/icon-cookie.svg';
import IconLock from '@mirinae/lessons/components/svg/icon-lock-black.svg';
import IconLessons from '@mirinae/lessons/components/svg/icon-lessons.svg';

const ModalPopupBack = styled.div`
    z-index: ${zIndex.feedbackPopup - 1};
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${os.isOthers ? 'rgba(60,60,59,.7)' : 'rgba(60,60,59,.58)'};
`;
const ModalPopupWrapper = styled.div`
    width: ${os.isOthers ? '440px' : '330px'};
    padding: ${os.isOthers ? '70px' : '50px'} ${os.isOthers ? '60px' : '35px'};
    background-color: ${lessonsPalette.primary.white};
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.202401);
    border-radius: 10px;
    text-align: center;
    color: ${palette.point.black};
    font-family: ${fontDefault};
`;
const PopupIcon = styled.div`
    margin-bottom: 20px;
`;
const ModalPopupTitle = styled.div`
    margin-bottom: 30px;
    line-height: 25px;
    font-size: 20px;
    font-weight: 800;
    color: ${lessonsPalette.grey[0]};
    svg {
        margin-right: 10px;
        margin-top: -4px;
        vertical-align: middle;
    }
`;
const ModalPopupMessage = styled.div`
    margin-bottom: 40px;
    line-height: 25px;
    color: ${lessonsPalette.grey[2]};
    font-size: 18px;
    font-weight: 500;
    white-space: pre-wrap;
    p + p {
        margin-top: 5px;
    }
`;
const ModalPopupButtons = styled.div`
`;
const DenyButton = styled(LessonButton)`
    width: 260px;
    height: 50px;
    margin-bottom: -15px;
    padding: 0 50px;
    margin-top: 5px;
    color: ${lessonsPalette.grey[4]};
    font-family: ${fontDefaultAlt};
    font-size: 17px;
    font-weight: 700;
    :hover {
        color: #838383;
    }
`;
const AgreeButton = styled(LessonButton)`
    width: 260px;
    height: 50px;
    padding: 0 50px;
    border-radius: 25px;
    background-color: ${props => (props.theme === 'isPremium' ? lessonsPalette.lessons[0] : lessonsPalette.primary.main)};
    color: ${lessonsPalette.primary.white};
    font-family: ${fontDefaultAlt};
    font-size: 17px;
    font-weight: 700;

    :hover {
        background-color: ${props => (props.theme === 'isPremium' ? '#C48A34' : lessonsPalette.darken[0])}; // temporary yellow color
    }
`;

/* **********************************************
 * theme: isPremium | wait | quit | cookie | guestLocked
 */
const ModalPopup = ({ theme, title, message, textDeny, onDeny, textAgree, onAgree }) => (
    <ModalPopupBack>
        <ModalPopupWrapper theme={theme}>
            <PopupIcon>
                {theme === 'wait' && <img src={IconClock} alt="" />}
                {theme === 'isPremium' && <img src={IconCrown} alt="" />}
                {theme === 'quit' && <img src={IconExitDoor} alt="" />}
                {theme === 'cookie' && <img src={IconCookie} alt="" />}
                {theme === 'guestLocked' && <img src={IconLock} alt="" />}
                {theme === 'preview' && <img src={IconLessons} alt="" />}
            </PopupIcon>
            <ModalPopupTitle theme={theme}>
                {title}
            </ModalPopupTitle>
            <ModalPopupMessage>
                {HtmlParser(message.replace(/\\n/g, '\n'))}
            </ModalPopupMessage>
            <ModalPopupButtons>
                {textAgree && <AgreeButton type="button" theme={theme} onClick={onAgree}>{textAgree}</AgreeButton>}
                {textDeny && <DenyButton type="button" onClick={onDeny}>{textDeny}</DenyButton>}
            </ModalPopupButtons>
        </ModalPopupWrapper>
    </ModalPopupBack>
);

export default ModalPopup;